import { render, staticRenderFns } from "./EditPricing.vue?vue&type=template&id=4a47eecf&scoped=true&"
import script from "./EditPricing.vue?vue&type=script&lang=js&"
export * from "./EditPricing.vue?vue&type=script&lang=js&"
import style0 from "./EditPricing.vue?vue&type=style&index=0&id=4a47eecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a47eecf",
  null
  
)

export default component.exports